import { defaultAppContextFromCronos } from '@contexts/app/AppContext';
import { AppContextFromCronos } from '@contexts/app/AppContextFromCronos';
import { extractDataFromHTML } from '@utils/extractDataFromHTML';

export function getAppContextFromCronos(root: HTMLElement): AppContextFromCronos {
    const dataFromRoot = <TKey extends keyof AppContextFromCronos>(key: TKey) =>
        extractDataFromHTML(root)(key, defaultAppContextFromCronos[key]);
    return {
        cultureCode: dataFromRoot('cultureCode'),
        devicePlatformId: dataFromRoot('devicePlatformId'),
        cid: dataFromRoot('cid'),
        aid: dataFromRoot('aid'),
        trafficGroupId: dataFromRoot('trafficGroupId'),
        origin: dataFromRoot('origin'),
        sessionId: dataFromRoot('sessionId'),
        correlationId: dataFromRoot('correlationId'),
        userId: dataFromRoot('userId'),
        languageId: dataFromRoot('languageId'),
        whitelabelId: dataFromRoot('whitelabelId'),
        machineName: dataFromRoot('machineName'),
        currency: dataFromRoot('currency'),
        clientVersion: dataFromRoot('clientVersion'),
        optInEmailSubscription: dataFromRoot('optInEmailSubscription'),
        isWebView: dataFromRoot('isWebView'),
        wlAppDeviceType: dataFromRoot('wlAppDeviceType'),
        blockedPhoneCountryCodes: dataFromRoot('blockedPhoneCountryCodes'),
        additionalRegex: dataFromRoot('additionalRegex'),
        isCnTunnel: dataFromRoot('isCnTunnel'),
    };
}
